'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import useLoadingStore from '@/lib/stores/loadingStore'
import Cookies from 'js-cookie'

const RootContainer = () => {
  const { setIsLoading } = useLoadingStore()
  const router = useRouter()

  useEffect(() => {
    setIsLoading(true)
    const token = Cookies.get('axp_access_token')
    if (token) {
      router.replace('/programs')
    } else {
      router.replace('/login')
    }
    setIsLoading(false)
  }, [router])

  return null
}

export default RootContainer
